import axios from "axios"

export const sendVerificationEmail = (userId: string) =>
	axios.post("/api/twirp/podpal.email.EmailService/SendVerificationEmail", {
		userId
	})
